import { config, handleResponse } from '../../_helpers';

export const serviceModesService = {
    getServiceModes,
    getServiceModeById,
    createServiceMode,
    updateServiceMode,
    deleteServiceModes,
    activation,
    getActiveServiceModes,
};

function getServiceModes(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/ServiceModes/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/ServiceModes/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getServiceModeById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ServiceModes/get/${id}`, requestOptions).then(handleResponse);
}
function createServiceMode(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ServiceModes`, requestOptions).then(handleResponse);
}
function updateServiceMode(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ServiceModes/update/${id}`, requestOptions).then(handleResponse);
}
function deleteServiceModes(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ServiceModes/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/ServiceModes/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function getActiveServiceModes() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ServiceModes/getIsActive`, requestOptions).then(handleResponse);
}